import config from 'packages/admin/pages/list/routes/paginate';

export default config;
